// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46e48c8c","453":"13250e99","732":"ac898a9f","977":"ca096098"}[chunkId] + ".chunk.js";
};